import {
  BenefitsList as PortalsBenefitsList,
  BenefitsListItemText,
} from '@portals/core/src/containers/BenefitsList/BenefitsList';
import React from 'react';

import { BenefitsList as BenefitsListModel } from '../../../models';
import { Consumer, Node } from '../../consumers/Consumer/Consumer';

interface BenefitListProps {
  node: BenefitsListModel;
}

export const BenefitsList: React.FC<BenefitListProps> = ({ node }) => {
  return (
    <PortalsBenefitsList headlineTitle={node?.headlineTitle} variant={node?.variant}>
      {node.items.map((item) => {
        return (
          <BenefitsListItemText
            key={item.id}
            tooltip={
              item.tooltip ? (
                <Consumer
                  node={
                    {
                      __component: 'intern.text',
                      text: item.tooltip,
                      variant: 'body2',
                    } as Node
                  }
                />
              ) : (
                false
              )
            }
            icon={item.icon ? <Consumer node={item.icon} /> : null}
            headline={item.headline}
          >
            {item.text ? (
              <Consumer
                node={
                  {
                    __component: 'intern.text',
                    text: item.text,
                    variant: 'body1',
                  } as Node
                }
              />
            ) : null}
          </BenefitsListItemText>
        );
      })}
    </PortalsBenefitsList>
  );
};
